import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import useStore from "../../../../store";

const LogoutModal = observer(() => {
  const navigate = useNavigate();
  const {
    AUTH: { setToken },
  } = useStore();

  const [desinationPage, setDesinationPage] = useState<string | null>("");
  const [logoutModal, setLogoutModal] = useState<boolean>(false);
  const closeLogoutModal = () => {
    navigate("/booking-detail");
    setLogoutModal(false);
  };

  useEffect(() => {
    const getDesinationPage = localStorage.getItem("desinationPage");
    setDesinationPage(getDesinationPage);

    const loginType = localStorage.getItem("login_type");
    if (loginType === "client") {
      setLogoutModal(true);
    }
  }, [setLogoutModal]);

  return logoutModal ? (
    <Modal
      className="primaryModal"
      open={logoutModal}
      onCancel={closeLogoutModal}
      centered
      title={false}
      footer={
        <div className="buttonGroup">
          <Button
            type="primary"
            onClick={() => {
              localStorage.clear();
              setToken(null);
              setLogoutModal(false);
            }}
          >
            Agree to Logout
          </Button>
          <Button type="default" onClick={closeLogoutModal}>
            Go Back
          </Button>
        </div>
      }
    >
      <p className="text-center pt-40 pb-20">
        You are already logged in to your <strong>Client Account</strong>.
        <br />
        You will be logout if you login in{" "}
        <strong>
          {desinationPage === "ebooking" ? "E-Booking" : "Travel Free"} Account
        </strong>
        .
      </p>
    </Modal>
  ) : null;
});

export default LogoutModal;
